import { USER_ROLES } from './constants.js';
/**
 * Singleton store for student questions
 */
class StudentQuestionStore {
	constructor() {
		this.questions = [];
		this.currentQuestion = null;
		this.userRole = USER_ROLES.STUDENT;
	}

	setQuestions(questions) {
		this.questions = questions || [];
	}

	getQuestions() {
		return [...this.questions];
	}

	getQuestion(id) {
		const qId = String(id);
		return this.questions.find(q => String(q.id) === qId);
	}

	setCurrentQuestion(id) {
		this.currentQuestion = this.getQuestion(id);
	}

	getCurrentQuestion() {
		return this.currentQuestion;
	}

	addQuestion(question) {
		this.questions.push(question);
	}

	updateQuestion(id, data) {
		const index = this.questions.findIndex(q => String(q.id) === String(id));
		if (index !== -1) {
			this.questions[index] = { ...this.questions[index], ...data };
		}
	}

	removeQuestion(id) {
		this.questions = this.questions.filter(q => String(q.id) !== String(id));
	}

	getQuestionsByStatus(status) {
		if (!status || status === 'all') {
			return this.questions;
		}
		return this.questions.filter(q => q.status === status);
	}

	setUserRole(role) {
		this.userRole = role || USER_ROLES.STUDENT;
	}

	getUserRole() {
		return this.userRole;
	}
}

// Export singleton instance
const studentQuestionStore = new StudentQuestionStore();

export { studentQuestionStore };
